<template>
    <div class="about">
      <TransitionGroup>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Bank Branch Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <p class="card-text text-danger italic">Any changes done here will reflect only invoices generated after the change was applied.</p>
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item=>!formHidden.includes(item))" :key="index">
                <float-select v-if="r=='bank_id'" label="Bank Name" :options="ddHolder.banks" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="ddHolder.banks.find((b)=>{return b.id==rowData[r]})"
                                                label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient"/>
                <float-inp v-else type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <a href="#" v-if="rowData['id']===null || rowData['id']<1" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Create', promptText: 'Solve the sum to create this bank branch record.', confirmLabel: 'Create', action: () => postBranch('post') })" >Create Entity</a>
            <template v-else>
              <a href="#" class="btn btn-warning me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Duplicate', promptText: 'Solve the sum to duplicate this bank branch record.', confirmLabel: 'Duplicate', action: () => duplicateCurrentRecord() })" >Duplicate</a>
              <a href="#" class="btn btn-success me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Update', promptText: 'Solve the sum to update this bank branch record.', confirmLabel: 'Update', action: () => postBranch('put') })" >Update Entity</a>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this bank branch record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>
        <cdTable :links="links" title="Branches" table-name="bank_branch" :hidden="hidden" :headers="headers" :gen-form="false" v-else @popForm="e=>setRowData(e)" ></cdTable>
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
        
      </TransitionGroup>
      
    </div>
  </template>
  <script>
  import floatInp from '@/parts/floatInp.vue';
  import { dropDownLinks } from '@/cd-links';
  import floatSelect from '@/parts/floatSelect.vue';
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { branchLinks } from '@/cd-links';
  export default{
    components:{
      cdTable, floatInp, floatSelect, ActionCaptchaModal
    },
    data(){
      return {
        links: branchLinks,
        headers:{
            id: "ID",
            code: "Code#",
            bank_id: "Bank name",
            "bank.name": "Bank name",
            name: "Branch name",
            ifsc: "IFSC #",
            location: "Location",
            address:"Address",
            other_details: "Other Details",
            status: "Status",
            createdAt: "Created On",
            updatedAt: "Updated On"
          },
          hidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt', */
            'bank_id'
          ],
          formHidden:['creatorId','createdAt','updatedAt','status','bank.name','ent_id'],
          disabled:['id'],
          showModal:false,
          rowData:{
              id: null,
              code: null,
              name: null,
              bank_id: null,
              ifsc: null,
              location: null,
              address: null,
              other_details: null,
              status: null,
          },
          ddHolder:{
            banks:[]
          },
          preFetch:false,
          loading: false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null,
      }
    },
    methods:{
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting bank branch',
            type: 'danger'
          });
        }
      },
      async postBranch(mode){
        try {
          this.loading=true;
          this.rowData.status=true;
          typeof this.rowData.bank_id=='object'? this.rowData.bank_id = this.rowData.bank_id.id : null;
          this.rowData['ent_id']=this.$store.getters.getEntity;
          await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData})
              .then(resp=>{

                if(resp.data.isLoggedIn){
                  this.$store.commit('addAlert', {
                        title: resp.data.title,
                        message: resp.data.msg,
                        type: resp.data.success? 'info' : 'danger'
                    });
                  resp.data.success? this.showModal=false : this.showModal=true;                            
                  }
                else this.$store.dispatch('loggedOut');
              })
              .catch(err=>{
                console.error('Error posting branch:', err);
                this.$store.commit('addAlert', {
                  title: "Error",
                  message: err.response?.data?.msg || err.message || "Error saving branch",
                  type: 'danger'
                });
              })
              .finally(() => {
                this.loading=false;
              })
        } catch(err) {
          console.error('Error in postBranch:', err);
          this.$store.commit('addAlert', {
            title: "Error",
            message: err.message || "Error processing form",
            type: 'danger'
          });
          this.loading=false;
        }
      },
      setRowData(e){
        this.rowData=e.rowData;
        this.rowData['bank_id']==undefined? this.rowData={bank_id:null,...this.rowData}:null;
        this.showModal=true;
      },
      async getDropDownData(table,listName) {
                    this.loading=true;
                    await this.$store.getters.getAxios.post(dropDownLinks[table],{ent_id:this.$store.getters.getEntity})
                        .then(resp=>{
                          if(!resp.data.isLoggedIn){
                                this.$store.dispatch('loggedOut');
                            }
                            else this.ddHolder[listName] =  resp.data.data;                         
                        })
                        // eslint-disable-next-line
                        .catch(err=>{
                            this.$store.commit('addAlert', {
                                title: "Error Getting DropDown Data for "+listName,
                                message: "Try after some time",
                                type: 'danger'
                            });
        
                        })
                },
    },
    mounted(){      
        this.getDropDownData('banks','banks');
        this.preFetch=true;
    }
  }
  </script>
  